import React from 'react'
import { Sidebar } from '../../Component/Sidebar/Sidebar'

const Bookmarks = () => {
  return (
    <div className='w-full bookmarks d-lg-none'>
      <Sidebar/>
    </div>
  )
}

export default Bookmarks